import apiClient from "./config";

const supportService = {
  // Get all support requests
  getAllSupportRequests: async () => {
    try {
      const response = await apiClient.get("/supports");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get support request by ID
  getSupportRequestById: async (requestId) => {
    try {
      const response = await apiClient.get(`/supports/${requestId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create new support request
  createSupportRequest: async (requestData) => {
    try {
      const response = await apiClient.post("/supports", requestData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update support request
  updateSupportRequest: async (requestId, requestData) => {
    try {
      const response = await apiClient.put(
        `/supports/${requestId}`,
        requestData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete support request
  deleteSupportRequest: async (requestId) => {
    try {
      const response = await apiClient.delete(`/supports/${requestId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default supportService;
